// extracted by mini-css-extract-plugin
export default {"publication":"publication_publication__PW9Vf","post":"publication_post__8Y9GY"};